import React, { Children, useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import { DEFAULT_BREAKPOINTS_HOME } from 'components/TalentsCarousel/constants/talentCarouselConstants';
//----------------------------------------------------------------------------------------
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import './Carouselmath.scss';
import {showPlaceHolderorImg} from 'containers/MundialViews/utils/mundialUtils';
import { FaChevronLeft,FaChevronRight } from 'react-icons/fa';
import {useSelector} from 'react-redux'

const SwiperCommon = ({matches,Card,title})=>{
  const [partidos,setPartidos] = useState(0);
  const {vcard_team_placeholder_img:placeholderVcard} = useSelector(state=>state.asset)
    const { isMobile } = useVerifyIsMobile(768);

    useEffect(()=>{
      setPartidos(matches)
    },[matches])

    const isFinals = ()=>{
      if(partidos?.length > 2){
        return true
      }
      return false
    }

    return(

 <div className="players-carousel">
      <div className="players-carousel__header">
        <h2 className="players-carousel__header__title">{partidos?.length > 0 ? title : ''}</h2>
        <div className="players-carousel__header__navigation" />
      </div>
      <div className="chevrones-back-match">
      <FaChevronLeft size={17} className='players-carousel__header__navigation__prev-b' />
      </div>
      <div className="chevrones-next-match">
      <FaChevronRight size={17} className='players-carousel__header__navigation__next-b' />

      </div>

      <Swiper
        className="mySwiper"
        navigation={{
          prevEl: '.players-carousel__header__navigation__prev-b',
          nextEl: '.players-carousel__header__navigation__next-b',
        }}
        breakpoints={DEFAULT_BREAKPOINTS_HOME}
        spaceBetween={24}
        initialSlide={4}
        slidesPerView={3.2}
        loop={isFinals()}
        style={{ marginTop: isMobile ? 0 : 24 }}
        watchOverflow
      >
         {matches?.map(player => (
          <SwiperSlide key={player.id}>
            <Card
              homeImg={showPlaceHolderorImg(
                player.homeParticipant?.nationality?.images?.flag,
                placeholderVcard,
              )}
              homeTitle={player.homeParticipant?.names?.full}
              awayImg={showPlaceHolderorImg(
                player.awayParticipant?.nationality?.images?.flag,
                placeholderVcard,
              )}
              awayTitle={player.awayParticipant?.names?.full}
              time={player.dateAndTimeInfo?.scheduledStartTimeUTC}
              id={player.id}
              status={player.status}
              state={player.state}
            />
          </SwiperSlide>
        ))}
       
      </Swiper>
    </div>
    )
}

export default SwiperCommon